import type { JobStatus } from '../../types/jobs';

interface JobStatusBadgeProps {
  status: JobStatus;
  size?: 'sm' | 'md';
}

const STATUS_CONFIG: Record<JobStatus, { label: string; dot: string; badge: string }> = {
  created:     { label: 'Created',     dot: 'bg-neutral-400',  badge: 'bg-neutral-100 text-neutral-700'  },
  assigned:    { label: 'Assigned',    dot: 'bg-blue-500',     badge: 'bg-blue-100 text-blue-700'        },
  in_progress: { label: 'In Progress', dot: 'bg-amber-500',    badge: 'bg-amber-100 text-amber-700'      },
  paused:      { label: 'Paused',      dot: 'bg-orange-400',   badge: 'bg-orange-100 text-orange-700'    },
  completed:   { label: 'Completed',   dot: 'bg-success-500',  badge: 'bg-success-100 text-success-700'  },
  cancelled:   { label: 'Cancelled',   dot: 'bg-red-400',      badge: 'bg-red-100 text-red-700'          },
};

function JobStatusBadge({ status, size = 'md' }: JobStatusBadgeProps) {
  const cfg = STATUS_CONFIG[status] || STATUS_CONFIG.created;
  const sizeClass = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-0.5 text-sm';

  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full font-medium ${sizeClass} ${cfg.badge}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${cfg.dot}`} />
      {cfg.label}
    </span>
  );
}

export default JobStatusBadge;
